import { styled } from 'goober';
import { forwardRef } from 'react';
import { appColors } from './useTheme';
export var TEWrapper = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
    });
});
export var TEToolbar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        padding: '20px 10px',
        alignItems: 'center',
    });
});
export var TEBar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        padding: '10px',
        gap: '5px',
        alignItems: 'center',
    });
});
export var TESearchBar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        padding: '0px 10px 10px 10px',
        gap: '5px',
        alignItems: 'center',
    });
});
export var TEBreadcrumb = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        cursor: 'pointer',
        fontSize: '18px',
        whiteSpace: 'nowrap',
        '&:hover': {
            opacity: 0.6,
        },
    });
});
export var TEGroupSelector = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: '40px',
        zIndex: 1,
        background: '#fff',
        padding: '8px 8px 16px',
        border: "1px solid ".concat(theme.colors.neutral.w200),
        borderRadius: '6px',
        minWidth: '335px',
    });
});
export var TEGroupItem = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, _b = _a.$isActive, $isActive = _b === void 0 ? false : _b;
    return ({
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: $isActive ? theme.colors.neutral.w300 : 'transparent',
        borderRadius: '6px',
        alignItems: 'center',
        minHeight: '32px',
        position: 'relative',
        '&:hover': {
            backgroundColor: theme.colors.neutral.w300,
        },
        '.expand-btn': {
            padding: '0px 10px',
            cursor: 'pointer',
            fontSize: '10px',
        },
        '.menu-btn': {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '10px',
            visibility: 'hidden',
        },
        '&:hover .menu-btn': {
            visibility: 'visible',
        },
        input: {
            width: '100%',
            fontSize: '11px',
            fontWeight: 'bold',
        },
    });
});
export var TEGroupItemName = styled('div')(function () { return ({
    paddingLeft: '3px',
    paddingRight: '8px',
    cursor: 'pointer',
    fontSize: '12px',
    minHeight: '32px',
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
}); });
export var TEChildGroup = styled('div')(function () { return ({
    cursor: 'pointer',
    position: 'relative',
}); });
export var TEChildGroupInnerBold = styled('div')(function () { return ({
    padding: '5px 10px',
    fontWeight: 'bold',
    visibility: 'hidden',
    whiteSpace: 'nowrap',
}); });
export var TEChildGroupInner = styled('div')(function () { return ({
    position: 'absolute',
    top: '0px',
    padding: '5px 10px',
    display: 'flex',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    '&:hover': {
        fontWeight: 'bold',
    },
}); });
export var TETableTab = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $acc = _a.$acc, $active = _a.$active, $editing = _a.$editing;
    var backgroundColor = theme.colors.neutral.w50;
    if ($active && $acc && !$editing) {
        backgroundColor = theme.colors.secondary.w500;
    }
    else if ($active && !$acc && !$editing) {
        backgroundColor = theme.colors.primary.w500;
    }
    else if ($active && $editing) {
        backgroundColor = '#fff';
    }
    var borderColor = $editing ? theme.colors.primary.w500 : backgroundColor;
    return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '7px 14px',
        background: backgroundColor,
        color: $active ? '#fff' : $acc ? theme.colors.secondary.w500 : theme.colors.primary.w500,
        border: "2px solid ".concat(borderColor),
        borderBottom: 'none',
        borderRadius: '6px 6px 0px 0px',
        marginRight: '8px',
        fontSize: '12px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        '.invisible-width-holder': {
            visibility: 'hidden',
            height: '1px',
            position: 'absolute',
            zIndex: -1,
        },
        input: {
            backgroundColor: '#fff',
            padding: '2px 2px',
            border: 'none',
            fontSize: '12px',
        },
    };
});
export var TableTagBadge = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: '#fff',
        padding: '5px 10px',
        borderRadius: '6px',
        fontSize: '11px',
        lineHeight: 1,
        height: '24px',
        backgroundColor: theme.colors.primary.w500,
        display: 'flex',
        alignItems: 'center',
        fontWeight: 'bold',
        margin: '5px 10px',
        width: 'fit-content',
        cursor: 'pointer',
        '&.acc': {
            color: theme.colors.secondary.w500,
            backgroundColor: 'transparent',
            fontWeight: 'normal',
            fontSize: '12px',
            paddingLeft: '0px',
        },
    });
});
export var TEAddTagRibbon = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '30px',
        backgroundColor: theme.colors.neutral.w50,
        display: 'flex',
        alignItems: 'center',
    });
});
export var TEAddTagLabel = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '13px',
        paddingLeft: '30px',
        fontWeight: 'bold',
        color: theme.colors.primary.w500,
    });
});
export var TETagInput = styled('input', forwardRef)(function (_a) {
    var theme = _a.theme, $invalid = _a.$invalid;
    return ({
        backgroundColor: 'transparent',
        color: theme.colors.ui.dark,
        fontSize: '13px',
        borderRadius: '0px',
        outline: 'none',
        padding: '4px 10px',
        width: '100%',
        border: "2px solid ".concat(theme.colors.primary.w500),
    });
});
export var TECustomInputBox = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: '#fff',
        width: 'auto',
        minWidth: '100px',
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
        padding: '0px 5px',
        border: "1px solid ".concat(theme.borderColor),
    });
});
export var TEPermission = styled('div')(function () { return ({
    height: '14px',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    lineheight: '14px',
    paddingLeft: '3px',
    fontSize: '11px',
    minHeight: '32px',
    color: appColors.neutral.w700,
}); });
export var TEPermissionCheckBox = styled('div')(function () { return ({
    listStyleType: 'none',
    paddingLeft: '6px',
    fontSize: '8px',
    minHeight: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    alignItems: 'left',
    accentColor: '#4285F4',
}); });
export var TEHeaderMenuWrapper = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $visible = _a.$visible, $left = _a.$left, $top = _a.$top;
    return ({
        position: 'fixed',
        left: $visible ? $left : '-100%',
        top: $top,
        visibility: $visible ? 'visible' : 'hidden',
        display: 'flex',
        flexDirection: 'column',
        margin: '0px',
        padding: '8px',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.borderColor,
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
        borderRadius: theme.borderRadius,
        backgroundColor: theme.colors.ui.white,
    });
});
export var TEConnectionPickerWrapper = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $visible = _a.$visible, $top = _a.$top, $left = _a.$left;
    return ({
        position: 'fixed',
        top: "".concat($top, "px"),
        left: $visible ? "".concat($left, "px") : '-100%',
        maxHeight: '500px',
        overflow: 'overlay',
        padding: '8px',
        backgroundColor: theme.colors.ui.white,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.borderColor,
    });
});
export var TEHeaderRenameInput = styled('input', forwardRef)(function (_a) {
    var theme = _a.theme, $visible = _a.$visible, $top = _a.$top, $left = _a.$left, $width = _a.$width, $height = _a.$height;
    return ({
        position: 'fixed',
        visibility: $visible ? 'visible' : 'hidden',
        top: "".concat($top, "px"),
        left: $visible ? "".concat($left, "px") : '-100%',
        width: "".concat($width, "px"),
        height: "".concat($height, "px"),
        padding: '4px',
        outline: 'none',
        backgroundColor: theme.colors.primary.w50,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.colors.primary.w500,
    });
});
